import type { ClientOptions, RpcClient } from "@redotech/rpc/client";
import { createRpcClient } from "@redotech/rpc/client";
import {
  rpcDefinition,
  type RedoManagedReturnsRpcDefinition,
} from "./definition";

export function createRedoManagedReturnsRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): RpcClient<RedoManagedReturnsRpcDefinition> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoManagedReturnsRpcClient = ReturnType<
  typeof createRedoManagedReturnsRpcClient
>;
